import React, { useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { Menu, Typography, Button } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Notification from './Notification';
import { news } from './fakeData';

const useStyles = makeStyles((theme) => ({
  popOver: {
    top: '70px !important',
    minHeight: '130px !important',
    width: 'auto'
  },
  popPaper: {
    minWidth: '295px',
    minHeight: '599px',
    maxWidth: 350,
    height: '50vh',

    '&::-webkit-scrollbar': {
      display: 'none'
    },
    '-ms-overflow-style': 'none',
    'scrollbar-width': 'none'
  },
  closeButton: {
    outline: 'none',
    textAlign: 'right',
    margin: '7px',
    cursor: 'pointer'
  },
  header: {
    display: 'flex',
    '& > span': {
      fontWeight: 'bold',
      fontSize: '28px',
      color: '#002380',
      marginLeft: '7px'
    }
  },
  title: {
    fontWeight: 'bold',
    textTransform: 'uppercase',
    fontSize: '22px',
    marginLeft: '10px'
  },
  notifContainer: {
    marginTop: '15px',
    '& > h3': {
      fontSize: '22px',
      fontWeight: 'inherit',
      color: '#142532',
      padding: '10px 20px'
    }
  },
  removeButtonContainer: {
    margin: '20px auto',
    textAlign: 'center'
  },
  removeButton: {
    borderRadius: 'unset',
    textTransform: 'capitalize',
    fontSize: '16px',
    fontWeight: 'bold'
  }
}));

const NotifMenu = ({ anchorElNotification, onClose }) => {
  const [newsFetched, setNewsFetched] = useState(news);
  const classes = useStyles();

  return (
    <Menu
      anchorEl={anchorElNotification}
      classes={{
        root: classes.popOver,
        paper: classes.popPaper
      }}
      className={classes.popOver}
      id="notification-menu"
      onClose={onClose}
      open={Boolean(anchorElNotification)}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}>
      <div className={classes.closeButton}>
        <CloseIcon onClick={onClose} />
      </div>

      {newsFetched.length ? (
        <>
          {/* Header */}
          <div className={classes.header}>
            <span>{newsFetched.length}</span>{' '}
            <Typography className={classes.title} color="initial" variant="h2">
              New Notifications
            </Typography>
          </div>
          {/* Today Notifications */}
          <div className={classes.notifContainer}>
            <h3>Today</h3>
            {newsFetched.map((article) => {
              return (
                article.id !== 5 && (
                  <Notification text={article.text} time={article.time} />
                )
              );
            })}
          </div>
          {/* Yesterday Notifications */}
          <div className={classes.notifContainer}>
            <h3>Yesterday</h3>
            {newsFetched.map((article) => {
              return (
                article.id === 5 && (
                  <Notification past text={article.text} time={article.time} />
                )
              );
            })}
          </div>
          <div className={classes.removeButtonContainer}>
            <Button
              className={classes.removeButton}
              color="primary"
              onClick={() => setNewsFetched([])}
              variant="outlined">
              remove notifications
            </Button>
          </div>
        </>
      ) : (
        <div style={{ color: '#002380', textAlign: 'center' }}>
          <h4>Up to Date!</h4>
        </div>
      )}
    </Menu>
  );
};

export default NotifMenu;
